enum ToastTypeVariants {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
}

export default ToastTypeVariants;